//Newsletter
function comprueba() {
  var boton = document.getElementById("subscribe");
  var input_mail = document.getElementById("newsletter_email");

  if (check.checked) {
    input_mail.disabled = false;
    boton.disabled = false;
    boton.classList.remove("button-newsletter");
    input_mail.focus();
  } else {
    boton.disabled = true;
    boton.classList.add("button-newsletter");
  }
}

$(document).ready(function () {
  if (document.getElementById("newsletter_email")) {
    var check = document.getElementById("check");
    document.getElementById("subscribe").disabled = true;
    //document.getElementById("newsletter_email").disabled = true;
    if (!check) {
      return;
    }
    check.addEventListener("change", comprueba, false);
  }
});

//menu Login en la barra del buscador

$(document).ready(function () {
  var menuLogin = $(".site-navigation .site-header-actions");
  var search = $(".site-header-main-content");

  menuLogin.remove();
  search.append(menuLogin);
});

//Form recuperar contraseña

$(document).ready(function () {
  $('a[href="#customer_recovery"]').on("click", function () {
    $("#customer_recovery").css("display", "block");
  });
});

//scroll automático categorias
$(window).on("load", function () {
  var container = $(
    "ul.tmenu_submenu.tmenu_submenu_type_automatic.tmenu_submenu--desktop"
  );
  var windowHeight = $(window).height();
  container.each(function (index) {
    var position = $(this).offset().top;
    var positionItem = windowHeight - position;
    $(this).css("max-height", positionItem);
  });
});

//footer acordion
$(window).on("load", function () {
  $(".has-accordion").on("click", function () {
    $(this).toggleClass("accordion--active");
  });
});
